import { ApiProduct } from '../../types';
import { ProductBox } from '../ProductListing/ProductBox/ProductBox';
import './ProductListingWithCard.css';

type ProductListinWithCardProps = {
	products: ApiProduct[];
	card: React.ReactNode;
};

export const ProductListingWithCard = ({ products, card }: ProductListinWithCardProps) => {
	return (
		<div className="product-listing">
			<div className="product-listing-card">{card}</div>
			{products.map((p) => (
				<ProductBox key={p.id} product={p} />
			))}
		</div>
	);
};
